import { React, useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation, useNavigate, Outlet } from "react-router-dom";

import styles from "./Account.module.css";
import Nav from "../../components/Nav/Nav";
import Footer from "../../components/Footer/Footer";

import { Link } from "react-router-dom";

import { StaticRoutes } from "../routes";

import TripBoard from "../../assets/BidProPlusTripBoardHalfLogo.png";
import Seniority from "../../assets/BidProPlusSeniorityHalfLogo.png";
import Bidding from "../../assets/BidProPlusBiddingHalfLogo.png";

import pilotAvatar from "../../assets/pilot-avatar.png";
import { AccountMenu } from "./AccountMenu/AccountMenu";
import environment from "../../environment";
import CancelSubscriptionModal from "../../components/CancelSubscriptionModal";
import classNames from "classnames";
import Loader from "../../components/Loader/Loader";

const Account = ({
  navList = [
    {
      label: "HOME",
      options: [],
      border: false,
      path: StaticRoutes.Home,
    },
    {
      label: "PRODUCTS",
      options: [
        { label: "BIDDING", path: StaticRoutes.Bidding },
        { label: "TRIPBOARD", path: StaticRoutes.TripBoard },
        { label: "SENIORITY", path: StaticRoutes.Seniority },
      ],
      border: false,
    },
    {
      label: "PRICING",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: false,
    },
    {
      label: "CONTACT US",
      options: [],
      border: false,
      path: StaticRoutes.Contact,
    },
    /*{
      label: "LOG IN",
      options: [],
      border: false,
      path: StaticRoutes.Login,
    },*/
    {
      label: "SIGN UP",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: true,
    },
  ],
  footerLists = [
    {
      header: "MENU",
      links: [
        { name: "Home", src: StaticRoutes.Home },
        { name: "Contact Us", src: StaticRoutes.Contact },
        { name: "Sign Up", src: StaticRoutes.Home },
      ],
    },
    {
      header: "PRODUCTS",
      links: [
        { name: "Bidding", src: StaticRoutes.Bidding },
        { name: "Trip Board", src: StaticRoutes.TripBoard },
        { name: "Seniority", src: StaticRoutes.Seniority },
        { name: "Pricing", src: StaticRoutes.UPSPricing },
      ],
    },
    {
      header: "TECH SUPPORT",
      links: [
        { name: "tech@bidpro.com", src: "mailto:tech@bidpro.com" },
        { name: "1-800-918-4980", src: "tel:18009184980" },
      ],
    },
  ],
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [accountData, setAccountData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [cancelTargetId, setCancelTargetId] = useState(null);
  const fetchProfileData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(environment.apiBase + "/UserGetAccount", {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const data = await response.json();
      setAccountData(data);
    } catch (err) {
      setError("Failed to load profile data. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProfileData();
  }, [fetchProfileData]);

  const navListWithNavigate = navList.map((item) => ({
    ...item,
    onClick: () => navigate(item.path),
    options: item.options?.map((option) => ({
      ...option,
      onClick: () => navigate(option.path),
    })),
  }));
  useEffect(() => {
    if (location.state?.showPasswordSuccess) {
      setShowToast(true);
      // Clear the state so it doesn’t persist on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);
  useEffect(() => {
    if (showToast) {
      const timer = setTimeout(() => setShowToast(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [showToast]);

  const testData = {
    name: "Tester Name",
    fleet: "fleet",
    seat: "seat",
    domicile: "domicile",
    gems: "050505",
    avatar: "https://picsum.photos/200",
    subType: "BidProPlus! Bundle",
    hasBundle: true,
    lastFour: "1234",
    price: "99.99",
    promoDate: "12/12/2023",
    history: {
      startDate: "01/01/2020",
      endDate: "01/01/2021",
    },
  };

  const onClick = () => {
    alert("New Option Clicked");
  };
  // const location = useLocation();
  const atRoot = location.pathname === "/account";
  const [isCancelModalOpen, setCancelModalOpen] = useState(false);
  useEffect(() => {
    fetchProfileData();
  }, [location]);
  const handleOpenCancelModal = (subscriptionId) => {
    setCancelTargetId(subscriptionId); // track the correct one
    setCancelModalOpen(true);
  };

  const handleCloseCancelModal = () => setCancelModalOpen(false);

  const handleConfirmCancel = async () => {
    setCancelModalOpen(false);

    try {
      const response = await fetch(
        environment.apiBase + "/account/cancel-subscription",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            deactivate: "true",
            currentSubscriptionId: cancelTargetId,
            timestamp: new Date().toISOString(),
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      await response.json();
      window.location.reload();
    } catch (error) {
      console.error("Cancellation failed", error);
    }
  };

  const fetchSubscriptionSubData = (billingNameBefore) => {
    switch (billingNameBefore) {
      case "Bidding & Seniority":
        return "Your subscription includes access to: Bidding & Seniority.";
      case "TripBoard":
        return "Your subscription includes access to: TripBoard.";
      case "BidPro Bundle":
        return "Your subscription includes access to: Tripboard, Bidding & Seniority.";
      default:
        return "";
    }
  };

  return (
    <>
      <Nav isStatic={true} navItems={navListWithNavigate} />
      {atRoot ? (
        <>
          <div className={styles.pageContainer}>
            {/* <div className={styles.menu}>
              <AccountMenu
                avatar={pilotAvatar}
                name={accountData?.FirstName}
                onClick={() => onClick()}
              />
            </div> */}

            {!loading ? (
              // loading false
              <>
                <div></div>
                {showToast && (
                  <div className={styles.toastSuccess}>Update Successful!</div>
                )}

                <div className={styles.welcome}>
                  <div>
                    <img className={styles.img} src={pilotAvatar} />
                  </div>
                  <div className={styles.userInfo}>
                    <h1>
                      Welcome {accountData?.FirstName} {accountData?.LastName}!
                    </h1>
                    <div>Gems {accountData?.UserName}</div>
                    <div>
                      {accountData?.EquipmentName} {accountData?.PositionName}{" "}
                      {accountData?.BaseName}
                    </div>
                  </div>
                  <div className={styles.btnEnd}>
                    <button
                      // className={styles.buttonV3}
                      className={classNames(
                        styles.buttonV3,
                        styles.buttonV3Width
                      )}
                      onClick={() =>
                        navigate("/account/update-profile", {
                          state: { step: "updateProfile" },
                        })
                      }
                    >
                      Go to Profile
                    </button>
                  </div>
                </div>

                {/* add in section for if user has no sub history */}
                {accountData?.HasSubHistory ? (
                  accountData?.IsActiveSub ? (
                    <>
                      {/* has sub history and active subs */}
                      {accountData.ActiveSubscriptions?.map((sub, index) => {
                        const isTrial = sub.IsTrial;

                        return (
                          <div key={index} className={styles.subs}>
                            <div className={styles.subHeader}>
                              Active Subscription: {sub.BillingName}
                            </div>
                            <div className={styles.subInfo}>
                              <div>
                                <div>
                                  You are subscribed to <b>{sub.BillingName}</b>
                                  .
                                </div>
                                <div>
                                  {fetchSubscriptionSubData(sub.BillingName)}
                                </div>
                              </div>

                              {!isTrial && (
                                <div className={styles.btnEnd}>
                                  <button
                                    className={styles.buttonV3}
                                    onClick={() =>
                                      navigate("/account/change-subscription", {
                                        state: {
                                          step: "changeSubscription",
                                          billingCycle: sub.BillingCycle,
                                          billingPrice: sub.BillingPrice,
                                          subscriptionId:
                                            sub.PayGateSubscriptionID,
                                        },
                                      })
                                    }
                                  >
                                    Change Sub Type
                                  </button>
                                </div>
                              )}
                            </div>

                            <div className={styles.cardInfo}>
                              <div>
                                Your card ending in {sub.LastFour || "XXXX"}{" "}
                                will be charged ${sub.BillingPrice}{" "}
                                {sub.BillingCycle === 1
                                  ? "monthly"
                                  : "annually"}
                                .
                              </div>

                              {!isTrial && (
                                <div className={styles.btnEnd}>
                                  <button
                                    className={styles.buttonV3}
                                    onClick={() =>
                                      navigate("/account/update-card", {
                                        state: {
                                          step: "payment",
                                          subscriptionId:
                                            sub.PayGateSubscriptionID,
                                        },
                                      })
                                    }
                                  >
                                    Update Card Info
                                  </button>
                                </div>
                              )}
                            </div>

                            {!isTrial && (
                              <div>
                                <button
                                  className={styles.btnCancel}
                                  onClick={() =>
                                    handleOpenCancelModal(
                                      sub.PayGateSubscriptionID
                                    )
                                  }
                                >
                                  Cancel Subscription
                                </button>
                                <CancelSubscriptionModal
                                  isOpen={isCancelModalOpen}
                                  onCloseButtonClick={handleCloseCancelModal}
                                  onConfirmCancel={() =>
                                    handleConfirmCancel(
                                      sub.PayGateSubscriptionID
                                    )
                                  }
                                />
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </>
                  ) : (
                    // no sub history inactive sub
                    <div className={styles.noSubHistory}>
                      <div className={styles.noSubCol}>
                        <div className={styles.subHeader}>
                          No Active Subscription
                        </div>
                        <div className={styles.infoSection}>
                          <p>
                            It does not look like our records indicate you have
                            an active subscription with us.
                          </p>
                          <p>
                            Click the "Sign Up" button to start our signup
                            process and register to one of our available
                            subscriptions!
                          </p>
                          <p>
                            Need more information about our packages? See our{" "}
                            <Link to={"/pricing/ups"}>Pricing</Link> page for
                            more information.
                          </p>
                        </div>
                      </div>
                      <div className={styles.btnEnd}>
                        <button
                          className={classNames(
                            styles.buttonV3,
                            styles.signUpButton,
                            styles.buttonV3Width
                          )}
                          onClick={() => {
                            navigate("/pricing/ups");
                          }}
                        >
                          Sign Up
                        </button>
                      </div>
                    </div>
                  )
                ) : (
                  // no sub history
                  <div className={styles.noSubHistory}>
                    <div className={styles.noSubCol}>
                      <div className={styles.subHeader}>
                        No Subscription History
                      </div>
                      <div className={styles.infoSection}>
                        <p>
                          We do not show a previous subscription for you. Click
                          the "Sign Up" button to start our signup process and
                          get started today with BidPro today!
                        </p>
                        <p>
                          Need more information about our packages? See our{" "}
                          <Link to={"/pricing/ups"}>Pricing</Link> page for more
                          information.
                        </p>
                      </div>
                    </div>
                    <div className={styles.btnEnd}>
                      <button
                        className={classNames(
                          styles.buttonV3,
                          styles.signUpButton,
                          styles.buttonV3Width
                        )}
                        onClick={() => {
                          navigate("/pricing/ups");
                        }}
                      >
                        Sign Up
                      </button>
                    </div>
                  </div>
                )}
              </>
            ) : (
              // loading true
              <div className={styles.loaderContainer}>
                <Loader color={"#3c4554"} size={75} />
              </div>
            )}
            {/* end add in section */}

            {accountData?.IsActiveSub ? (
              <>
                <div className={styles.weblinks}>
                  {accountData?.BillingName === "BidPro Bundle" ||
                  accountData?.BillingName === "TripBoard" ? (
                    <div className={styles.link}>
                      <img className={styles.logo} src={TripBoard} />
                      <div>
                        Go to <b>Web TripBoard</b>{" "}
                        <a
                          className={styles.green}
                          href={"https://tripboard.bidproplus.com/"}
                        >
                          here
                        </a>
                      </div>
                      <div>
                        Download <b>Mobile TripBoard App</b>{" "}
                        <a
                          className={styles.green}
                          href={
                            "https://apps.apple.com/us/app/bidpro-tripboard-for-ipa/id1590630416"
                          }
                        >
                          here
                        </a>
                      </div>
                    </div>
                  ) : null}

                  {accountData?.BillingName === "BidPro Bundle" ||
                  accountData?.BillingName === "Bidding & Seniority" ? (
                    <>
                      <div>
                        <div className={styles.link}>
                          <img className={styles.logo} src={Seniority} />
                        </div>
                        <div className={styles.marginTop}></div>
                        <div>
                          Download <b>Seniority App</b>{" "}
                          <a
                            className={styles.yellow}
                            href={
                              "https://apps.apple.com/us/app/bidpro-seniority-for-ipa/id1527711444"
                            }
                          >
                            here
                          </a>
                        </div>
                      </div>
                      <div>
                        <div className={styles.link}>
                          <img className={styles.logo} src={Bidding} />
                        </div>
                        <div>
                          Go to <b>Web Bidder</b>{" "}
                          <a
                            className={styles.blue}
                            href={"https://bidding.bidproplus.com/"}
                          >
                            here
                          </a>
                        </div>
                        <div>
                          Download <b>Mobile Bidding App</b>{" "}
                          <a
                            className={styles.blue}
                            href={
                              "https://apps.apple.com/us/app/bidpro-bidding-for-ipa/id1251050627"
                            }
                          >
                            here
                          </a>
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
                <div className={`${styles.footer} mb-4`}>
                  Remember to bookmark your web pages for easy access.
                </div>
              </>
            ) : (
              <>
                <div className={styles.gapSpace}></div>
              </>
            )}
          </div>
          <Footer lists={footerLists} inverse={true} />
        </>
      ) : (
        <>
          <div className={styles.pageContainer}>
            <div className={styles.menu}>
              {/* <AccountMenu
                avatar={pilotAvatar}
                name={"Tester Name"}
                onClick={() => onClick()}
              /> */}
            </div>
          </div>
          <Outlet />
        </>
      )}
    </>
  );
};

Account.propTypes = {
  navList: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      options: PropTypes.array,
      border: PropTypes.bool,
      onClick: PropTypes.func.isRequired,
    })
  ),
  footerLists: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string,
      links: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          src: PropTypes.string,
        })
      ),
    })
  ),
};

export default Account;
